/** Human-readable poll lifecycle (internal `phase` strings stay stable). */
export function pollPhaseLabel(phase: string): string {
	switch (phase) {
		case "collecting":
			return "Getting ready";
		case "voting":
			return "Voting is open";
		case "revealed":
			return "Results are shared";
		default:
			return "Status updating";
	}
}

export function votingStyleLabel(votingType: string): string {
	switch (votingType) {
		case "ranked":
			return "Ranked choice";
		case "quadratic":
			return "Weighted picks (quadratic voting)";
		default:
			return "Voting style";
	}
}
